module.exports = new __parcel__URL__("cathedral.1aba4e48.webp").toString();